<template>
  <div class="menue-left" :class="defaultSettings.menuLeftTheme=='light'?'menue-left-light':''" style="" @mouseenter="mouseState='in'" @mouseleave="mouseState='out'">
    <MenuTop @searchChange="searchChange"  @allHideChange="allHideChange"></MenuTop>
    <div v-if="defaultSettings.leftMenuType=='default'" class="menue-left-box">
      <ul class="menue-left-box-ul" v-for="(item,key0) in menusList" :key="key0">
        <div class="menue-left-box-ul-title" @click="shousuoHandle(item,key0)" :title="$t(item?.meta?.title)">
          <!-- width: 16px; -->
          <img
            style="height: 21px;margin-right: 10px;"
            v-if="menusArr.includes(item?.meta?.title)"
            :src="require(`@/assets/menu/${menusArr.indexOf(item?.meta?.title)+1}.png`)"
            alt=""
            srcset="">
          <a-icon v-else-if="(typeof item.meta.icon == 'object')" slot="prefix" :component="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
          <a-icon v-else slot="prefix" :type="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
          <span class="font16B">{{ $t(item?.meta?.title) }}</span>
        </div>
        <div  v-if="shousuoPath.indexOf(item.path) == -1 && !isAllHide" class="menue-left-box-ul-children">
          <template v-for="(itemChild, key1) in item.childrenMenu">
            <div
            v-if="
                itemChild?.name.toLowerCase().includes('http://') || itemChild?.name.toLowerCase().includes('https://')
              "
              class="router-link"
              active-class="active-router-link"
              :key="key1"
              :to="'/'+itemChild?.path"
              :title="$t(itemChild?.meta?.title)"
              @click="routerJump(itemChild)">
              <span class="router-link-title font14M">
                {{ $t(itemChild?.meta?.title) }}
              </span>
            </div>

            <router-link
            v-else
              class="router-link"
              active-class="active-router-link"
              :key="key1"
              :to="'/'+itemChild?.path"
              :title="$t(itemChild?.meta?.title)">
              <span class="router-link-title font14M">
                {{ $t(itemChild?.meta?.title) }}
              </span>
            </router-link>
          </template>
          

        </div>
      </ul>
    </div>
    <div v-if="defaultSettings.leftMenuType=='unfold'" class="menue-left-box  menue-unfold">
      <ul class="menue-left-box-ul" v-for="(item,key0) in menusList" :key="key0">
        <div class="menue-left-box-ul-title" @click="shousuoHandle(item,key0)" :title="$t(item?.meta?.title)">
          <!-- width: 16px; -->
          <div style="display: flex;align-items: center;">
            <img
              style="height: 21px;margin-right: 10px;"
              v-if="menusArr.includes(item?.meta?.title)"
              :src="require(`@/assets/menu/${menusArr.indexOf(item?.meta?.title)+1}.png`)"
              alt=""
              srcset="">
            <a-icon v-else-if="(typeof item.meta.icon == 'object')" slot="prefix" :component="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
            <a-icon v-else slot="prefix" :type="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
            <span class="font16B">{{ $t(item?.meta?.title) }}</span>
          </div>
          <div style="display: flex;align-items: center;">
            <a-icon v-if="shousuoPath.indexOf(item.path) == -1 && !isAllHide" type="down" style="color: #fff;font-size: 12px;"/>
            <a-icon v-else type="up" style="color: #fff;font-size: 12px;" />
          </div>
        </div>
        <div v-if="shousuoPath.indexOf(item.path) == -1 && !isAllHide" class="menue-left-box-ul-children">
          <!-- <router-link
            class="router-link"
            active-class="active-router-link"
            v-for="(itemChild,key1) in item.childrenMenu"
            :key="key1"
            :to="'/'+itemChild?.path"
            :title="$t(itemChild?.meta?.title)">
            <span class="router-link-title font14M">
              {{ $t(itemChild?.meta?.title) }}
            </span>
          </router-link> -->
          <template v-for="(itemChild, key1) in item.childrenMenu">
            <div
              v-if="
                itemChild?.name.toLowerCase().includes('http://') || itemChild?.name.toLowerCase().includes('https://')
              "
              class="router-link"
              style="cursor: pointer"
              :key="key1"
              @click="routerJump(itemChild)"
            >
              <span class="router-link-title font14M">
                {{ $t(itemChild?.meta?.title) }}
              </span>
            </div>
            <router-link
              v-else
              class="router-link"
              active-class="active-router-link"
              :key="key1"
              :title="$t(itemChild?.meta?.title)"
              :to="'/' + itemChild?.path"
            >
              <span class="router-link-title font14M">
                {{ $t(itemChild?.meta?.title) }}
              </span>
            </router-link>
          </template>

        </div>
      </ul>
    </div>
    <div v-if="defaultSettings.leftMenuType=='multilevelMenu'" class="menue-left-box  menue-multilevelMenu">
      <ul v-if="false" class="menue-left-box-ul" v-for="(item,key0) in menusList" :key="key0">
        <div class="menue-left-box-ul-title" @click="shousuoHandle(item,key0)" :title="$t(item?.meta?.title)">
          <!-- width: 16px; -->
          <div style="display: flex;align-items: center;">
            <img
              style="height: 21px;margin-right: 10px;"
              v-if="menusArr.includes(item?.meta?.title)"
              :src="require(`@/assets/menu/${menusArr.indexOf(item?.meta?.title)+1}.png`)"
              alt=""
              srcset="">
            <a-icon v-else-if="(typeof item.meta.icon == 'object')" slot="prefix" :component="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
            <a-icon v-else slot="prefix" :type="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
            <span class="font16B">{{ $t(item?.meta?.title) }}4</span>
          </div>
          <div style="display: flex;align-items: center;">
            <a-icon v-if="shousuoPath.indexOf(item.path) == -1 && !isAllHide" type="down" style="color: #fff;font-size: 12px;"/>
            <a-icon v-else type="up" style="color: #fff;font-size: 12px;" />
          </div>
        </div>
        <div v-if="shousuoPath.indexOf(item.path) == -1 && !isAllHide" class="menue-left-box-ul-children">
          <router-link
            class="router-link"
            active-class="active-router-link"
            v-for="(itemChild,key1) in item.childrenMenu"
            :key="key1"
            :to="'/'+itemChild?.path"
            :title="$t(itemChild?.meta?.title)">
            <span class="router-link-title font14M">
              {{ $t(itemChild?.meta?.title) }}3
            </span>
          </router-link>

        </div>
      </ul>
      <a-menu
        mode="inline"
        theme="light"
        :inlineCollapsed="isAllHide"
        :selectedKeys="[$route.path]"
      >
        <template v-for="(item) in menusList">
          <a-menu-item v-if="isShowOnlyThisMenu(item)" :key="'/'+item?.path">
            <!-- <div style="display: flex;align-items: center;">

              <router-link
                class="router-link"
                active-class="active-router-link"
                :to="'/'+item?.path"
                :title="item?.meta?.title">
                <a-icon class="menue-icon" v-if="(typeof (item.meta.icon) === 'object')" slot="prefix" :component="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
                <a-icon class="menue-icon" v-else slot="prefix" :type="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
                <span class="router-link-title font14M">
                  {{ item?.meta?.title }}
                </span>
              </router-link>
            </div> -->
            <router-link
              v-if="item?.path.indexOf('http://')===-1&&item?.path.indexOf('https://')===-1"
              class="router-link"
              active-class="active-router-link"
              :to="'/'+item?.path"
              :title="item?.meta?.title">
              <span class="router-link-title font16B" style="display: flex;align-items: center;">
                <a-icon class="menue-icon" v-if="(typeof (item.meta.icon) === 'object')" slot="prefix" :component="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
                <a-icon class="menue-icon" v-else slot="prefix" :type="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
                {{ item?.meta?.title }}
              </span>

            </router-link>
            <div
              v-else
              class="router-link"
              active-class="active-router-link"
              :href="item?.path"
              :target="item.meta.target"
              :title="item?.meta?.title"
              @click="routerJump(item)">

              <span class="router-link-title font14B" style="display: flex;align-items: center;">
                <a-icon class="menue-icon" v-if="(typeof (item.meta.icon) === 'object')" slot="prefix" :component="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
                <a-icon class="menue-icon" v-else slot="prefix" :type="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
                {{ item?.meta?.title }}
                <!-- {{ item?.path }}2 -->
              </span>

            </div>

          </a-menu-item>
          <sub-menu v-else-if="!item.hidden" :key="'/'+item?.path" :menu-info="item" />
        </template>
      </a-menu>
    </div>

    <div v-if="defaultSettings.leftMenuShrink" class="menue-left-icon" :class="mouseState=='out'?'mouse-out':'mouse-in'" @click="setMenuStatus" @mouseenter="mouseState='in'">
      <img
        class="menue-left-icon-hidden"
        :src="hiddenImg"
      />
      <img
        class="menue-left-icon-open"
        :src="openImg"
      />
    </div>
  </div>
</template>

<script>
import MenuTop from '../MenuTop'
import Icon from 'ant-design-vue/es/icon'
import defaultSettings from '@/config/defaultSettings'
import hiddenImg from './img/hidden.png'
import openImg from './img/open.png'

import { Menu } from 'ant-design-vue'

/**
 * @desc 判断是否只显示当前一级菜单
 * @param {  }
 * @version: 1.0.0
 */
function isShowOnlyThisMenu(item) {
  // console.log('getHaveChildrenMenu>>>>>>>>>>>', item)

  let haveChildrenMenu = !item.hidden
  if (item.children && item.children.length > 0) {
    let hiddenNum = 0
    item.children.forEach(itemC => {
      if (itemC.hidden) {
        hiddenNum++
      }
    })
    haveChildrenMenu = haveChildrenMenu && (hiddenNum === item.children.length)
  }

  return haveChildrenMenu
}
const SubMenu = {
  template: `
      <a-sub-menu :key="'/'+menuInfo?.path" v-bind="$props" v-on="$listeners">
        <span slot="title">
          
          <span class="router-link-title font16B" style="display: flex;align-items: center;">
            <a-icon class="menue-icon" v-if="(typeof (menuInfo.meta.icon) === 'object')" slot="prefix" :component="menuInfo.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
            <a-icon class="menue-icon" v-else slot="prefix" :type="menuInfo.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
            {{ menuInfo?.meta?.title }}
          </span>
        </span>
        <template v-for="item in menuInfo.children">
          <a-menu-item v-if="isShowOnlyThisMenu(item)" :key="'/'+item?.path">
            <router-link
              v-if="item?.path.indexOf('http://')===-1&&item?.path.indexOf('https://')===-1"
              class="router-link"
              active-class="active-router-link"
              :to="'/'+item?.path"
              :title="item?.meta?.title">
              <span class="router-link-title font14B" style="display: flex;align-items: center;">
                <a-icon class="menue-icon" v-if="(typeof (item.meta.icon) === 'object')" slot="prefix" :component="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
                <a-icon class="menue-icon" v-else slot="prefix" :type="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
                {{ item?.meta?.title }}
              </span>
            </router-link>
            <div
              v-else
              class="router-link"
              active-class="active-router-link"
              :href="item?.path"
              :target="item.meta.target"
              :title="item?.meta?.title"
              @click="routerJump(item)">
              <span class="router-link-title font14B" style="display: flex;align-items: center;">
                <a-icon class="menue-icon" v-if="(typeof (item.meta.icon) === 'object')" slot="prefix" :component="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
                <a-icon class="menue-icon" v-else slot="prefix" :type="item.meta.icon" style="font-size: 18px;color: #fff;margin-right: 10px;"/>
                {{ item?.meta?.title }}
              </span>

            </div>
            
          </a-menu-item>
          <sub-menu v-else-if="!item.hidden" :key="'/'+item?.path" :menu-info="item" />
        </template>
      </a-sub-menu>
    `,
  name: 'SubMenu',
  // must add isSubMenu: true
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    // Cannot overlap with properties within Menu.SubMenu.props
    menuInfo: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    isShowOnlyThisMenu,
    routerJump(item) {
      window.open(item.meta.permission.toLowerCase(), '_blank')
    },
  }
}
export default {
  components: {
    MenuTop,
    Icon,
    'sub-menu': SubMenu
  },
  props: {
    menus: {
      type: Array,
      require: true,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      searchMenu: '',
      menusArr: ['驾驶舱', '用户管理', '场地管理', '设备管理', '财务管理', '运营中心', '运维工单', '系统设置'],
      defaultSettings,
      hiddenImg,
      openImg,
      mouseState: 'out',
      isAllHide: false, // 是否收缩
      shousuoPath: [], // 收缩的路径
      shousuoPathAll: [], // 收缩的路径
    }
  },
  computed: {
    menusList() {
      let list = []
      this.menus.forEach(item => {
        this.shousuoPathAll.push(item.path) // 收缩的路径
        if(defaultSettings.isShowTopMenu){
          if (!item.hidden&& item.meta.menuId === this.multilevelMenuId) {
            let isSearchResult = false // 是否有搜索出结果
            if (item.children) {
              const children = item.children.filter((mapItem) => {
                if (!mapItem.hidden&&mapItem?.path!='tongjizhongxin/profit') {
                  // 如果用户使用搜索菜单
                  if (this.searchMenu) {
                    // 如果这个一级菜单下有搜索结果
                    if (mapItem?.meta?.title.indexOf(this.searchMenu) !== -1||this.$t(mapItem?.meta?.title).indexOf(this.searchMenu) !== -1) {
                      isSearchResult = true
                      return mapItem
                    }
                  } else {
                    return mapItem
                  }
                }
              })
              item['childrenMenu'] = children
            } else {
              item['childrenMenu'] = []
            }

            // 如果用户使用搜索菜单
            if (this.searchMenu) {
              // 如果这个一级菜单下有搜索结果
              if (isSearchResult) {
                if(defaultSettings.isShowTopMenu){
                  list = item.childrenMenu
                }else{
                  list.push(item)
                }
              }
            } else {
              if(defaultSettings.isShowTopMenu){
                list = item.childrenMenu
              }else{
                list.push(item)
              }
            }
          }
        }else{
          if (!item.hidden) {
            let isSearchResult = false // 是否有搜索出结果
            if (item.children) {
              const children = item.children.filter((mapItem) => {
                if (!mapItem.hidden&&mapItem?.path!='tongjizhongxin/profit') {
                  // 如果用户使用搜索菜单
                  if (this.searchMenu) {
                    // 如果这个一级菜单下有搜索结果
                    if (mapItem?.meta?.title.indexOf(this.searchMenu) !== -1||this.$t(mapItem?.meta?.title).indexOf(this.searchMenu) !== -1) {
                      isSearchResult = true
                      return mapItem
                    }
                  } else {
                    return mapItem
                  }
                }
              })
              item['childrenMenu'] = children
            } else {
              item['childrenMenu'] = []
            }

            // 如果用户使用搜索菜单
            if (this.searchMenu) {
              // 如果这个一级菜单下有搜索结果
              if (isSearchResult) {
                if(defaultSettings.isShowTopMenu){
                  list = item.childrenMenu
                }else{
                  list.push(item)
                }
              }
            } else {
              if(defaultSettings.isShowTopMenu){
                list = item.childrenMenu
              }else{
                list.push(item)
              }
            }
          }
        }
        
      })
      this.shousuoPathAll = [...new Set(this.shousuoPathAll)] // 去重收缩的路径
      console.log('list>>>>', list)

      return list
    }
  },
  created() {
    console.log('菜单>>>>>', this.menus)
    console.log('菜单>>>>>menusList>>>>', this.menusList)
  },
  methods: {
    
    routerJump(item) {
      window.open(item.meta.permission.toLowerCase(), '_blank')
    },
    // 搜索菜单
    searchChange(name) {
      this.searchMenu = name
    },
    isShowOnlyThisMenu,
    // 点击收缩
    shousuoHandle(item, key0) {
      let list = Object.assign([], this.shousuoPath)
      const index = list.indexOf(item.path)

      if (index !== -1) {
        list.splice(index, 1) // 存在则删除
      } else {
        list.push(item.path) // 不存在则添加
      }
      this.shousuoPath = Object.assign([], list)
    },
    setMenuStatus() {
      this.$store.dispatch('setMenuHidden', !this.menuHidden)
    },
    allHideChange() {
      if (this.shousuoPath.length > 0) {
        this.shousuoPath = [] // 收缩后，收缩状态为false
      } else {
        this.shousuoPath = Object.assign([], this.shousuoPathAll)
      }
      console.log('this.shousuoPath>>>>', this.shousuoPath);
      
      this.isAllHide = false // 收缩后，收缩状态为false
    },
  }

}
</script>

<style lang="less" scoped>

.menue-left {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 210px;
  padding: 11px 0 0;
  // height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: #2878FF !important;
  z-index: 1100;
  .menue-left-box {
    flex: 1;
    padding: 0 16px;
    overflow-y: auto;

    .menue-left-box-ul {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 0;
      margin-bottom: 8px;
      .menue-left-box-ul-title {
        display: flex;
        align-items: center;
        padding-left: 16px;
        margin-bottom: 10px;
        cursor: pointer;

        span {
          color: #FFFFFF;
        }
      }

      .menue-left-box-ul-children {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        transition: all 3s;

        .router-link {
          display: flex;
          align-items: center;
          width: 50%;
          // height: 30px;
          // line-height: 30px;
          // padding-top: 1px;
          padding-left: 16px;
          padding-top: 8px;
          padding-bottom: 8px;
          text-align: left;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          color: #FFFFFF;
          margin-bottom: 8px;
          cursor: pointer;

          .router-link-title {
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;

            line-height: 1;
          }

        }

        .active-router-link {
          background: #FFFFFF;

          .router-link-title {
            color: #2878FF;
          }

        }

      }

    }

    &.menue-unfold {
      padding: 0;
      .menue-left-box-ul {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 0;
        margin-bottom: 8px;
        .menue-left-box-ul-title {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-left: 32px;
          padding-right: 16px;
          margin-bottom: 10px;
          cursor: pointer;

          span {
            color: #FFFFFF;
          }
        }

        .menue-left-box-ul-children {
          flex-direction: column;

          .router-link {
            width: 100%;
            padding-left: 63px;
            padding-right: 16px;
            padding-top: 12px;
            padding-bottom: 12px;
          }

          .active-router-link {
            background: #2f71e1;

            .router-link-title {
              // color: #2878FF;
              color: #FFFFFF;
            }

          }

        }

      }
    }

    &.menue-multilevelMenu {
      padding: 0;

      .ant-menu-dark {
        background: transparent;
      }

      .ant-menu-dark .ant-menu-inline.ant-menu-sub {
        background: transparent;
      }

      .ant-menu-sub {
        background: transparent;
      }

      // .router-link {
      //   width: 100%;
      //   padding-left: 63px;
      //   padding-right: 16px;
      //   padding-top: 12px;
      //   padding-bottom: 12px;
      // }

      // .active-router-link {
      //   // background: #2f71e1;

      //   .router-link-title {
      //     // color: #2878FF;
      //     color: #FFFFFF;
      //   }

      // }

      .router-link-title {
        color: #FFFFFF;
      }
      .ant-menu-item-selected {
        background: #FFFFFF;

        .router-link-title {
          color: #2878FF;
        }
      }
    }

    .ant-menu-dark .ant-menu-inline.ant-menu-sub {
      background: transparent;
    }

   &::-webkit-scrollbar {
      display: none;
    }
  }

  .menue-left-icon {
    display:flex;
    justify-content:center;
    align-items:center;
    position: absolute;
    top: 40%;
    right: -22px;

    background-color: rgb(250, 250, 250);
    border: 1px solid rgb(222, 224, 226);
    // background-color: #2878FF !important;
    transition: 0.3s ease-in-out;
    visibility: hidden;
    opacity: 0;
    width: 16px;
    height: 44px;
    flex-shrink: 0;
    border-radius: 8px;
    z-index: 999999999999;
    cursor: pointer;

    img {
      width: 12px;
      &.menue-left-icon-open {
        display: none;
      }
    }

    &.mouse-in {
      visibility: visible !important;
      opacity: 1 !important;
    }

  }
}

</style>

<style lang="less">
.menue-left {
  background: #2878FF !important;
  .ant-menu-sub {
    background: transparent;
    box-shadow: none;
  }

  .menue-multilevelMenu {
      padding: 0;

    .ant-menu-dark {
      background: transparent;
      box-shadow: none;
    }

    .ant-menu-dark .ant-menu-inline.ant-menu-sub {
      background: transparent;
      box-shadow: none;
    }

    .ant-menu-sub {
      background: transparent;
      box-shadow: none;
    }

    // .router-link {
    //   width: 100%;
    //   padding-left: 63px;
    //   padding-right: 16px;
    //   padding-top: 12px;
    //   padding-bottom: 12px;
    // }

    // .active-router-link {
    //   // background: #2f71e1;

    //   .router-link-title {
    //     // color: #2878FF;
    //     color: #FFFFFF;
    //   }

    // }

    .router-link-title {
      color: #FFFFFF;
    }
    .ant-menu-item-selected {
      background: #FFFFFF;

      .menue-icon {
        color: #2878FF !important;
      }

      .router-link-title {
        color: #2878FF;
      }
    }

    .ant-menu-item,.ant-menu-submenu-title {
      display: flex;
      align-items: center
    }

    .ant-menu-item:active {
      background: #FFFFFF !important;
    }
  }

  &.menue-left-light {
    background: #FFFFFF !important;


    .menue-left-box {

      .menue-left-box-ul {
        .menue-left-box-ul-title {

          span {
            color: #3a3a3a;
          }

          .anticon {
            color: #3a3a3a !important;
          }
        }

        .menue-left-box-ul-children {

          .router-link {
            color: #3a3a3a;

          }

          .active-router-link {
            background: #e8f3ff;

            .router-link-title {
              color: #70a1ff;
            }

          }

        }

      }

      &.menue-unfold {
        .menue-left-box-ul {
          .menue-left-box-ul-title {

            span {
              color: #3a3a3a;
            }
          }

          .menue-left-box-ul-children {

            .active-router-link {
              background: #e8f3ff;

              .router-link-title {
                color: #70a1ff;
              }

            }

          }

        }
      }

      &.menue-multilevelMenu {

        .router-link-title {
          color: #3a3a3a;
        }
        .ant-menu-item-selected {
          background: #e8f3ff;

          .router-link-title {
            color: #70a1ff;
          }
        }
      }
    }

    .menue-left-icon {
      background-color: rgb(250, 250, 250);
      border: 1px solid rgb(222, 224, 226);
      // background-color: #2878FF !important;

    }


    .ant-menu-sub {
      background: transparent;
      box-shadow: none;
    }

    .menue-icon {
      color: #3a3a3a !important;
    }

    .menue-multilevelMenu {
        padding: 0;

      .ant-menu-dark {
        background: transparent;
        box-shadow: none;
      }

      .ant-menu-dark .ant-menu-inline.ant-menu-sub {
        background: transparent;
        box-shadow: none;
      }

      .ant-menu-sub {
        background: transparent;
        box-shadow: none;
      }
      .router-link-title {
        color: #3a3a3a;
      }
      .ant-menu-item-selected {
        background: #e8f3ff;

        .menue-icon {
          color: #70a1ff !important;
        }

        .router-link-title {
          color: #70a1ff;
        }
      }

      .ant-menu-item, .ant-menu-submenu-title {
        display: flex;
        align-items: center
      }

      .ant-menu-item:active {
        background: #e8f3ff !important;
      }
    }
  }
}
</style>
